import React, { Fragment, useState } from "react";
import "./Styles.css";
import MultiTenantHelper from "../../../Components/Info/MultiTenant/Index";

const InfoMultiTenantInfraInformationPage = () => {
  return (
    <Fragment>
        <MultiTenantHelper />
    </Fragment>
  );
}

export default InfoMultiTenantInfraInformationPage;